export enum Crud {
  CREATE = 'c',
  READ = 'r',
  UPDATE = 'u',
  DELETE = 'd',
}

export enum AccessTypes {
  All = 'All',
  Selected = 'Selected',
  OnlyMe = 'OnlyMe',
  AllowSelected = 'AllowSelected',
  BlockSelected = 'BlockSelected',
}

export enum AccessSubjectTypes {
  User = 'User',
  ApiKey = 'ApiKey',
}

export type TAccessRights = {
  [Crud.CREATE]: boolean;
  [Crud.READ]: boolean;
  [Crud.UPDATE]: boolean;
  [Crud.DELETE]: boolean;
};

export interface IAccessRightsBody {
  id: string;
  subjectid: string;
  rights: TAccessRights;
  metadata?: IAccessRightsMetadata
}

export interface IEntityAccessRights extends IAccessRightsBody {
  accesstype: AccessTypes;
  subjecttype: AccessSubjectTypes;
}

export interface IAccessRightsMetadata {
  accesstype: AccessTypes;
  restrictedby: string;
}

export const READ_ONLY_ACCESS_RIGHTS: Readonly<TAccessRights> = {
  c: false, r: true, u: false, d: false,
};

export const FULL_ACCESS_RIGHTS: Readonly<TAccessRights> = {
  c: true, r: true, u: true, d: true,
};
